// Swap point between the mock backend (frontend-first) and the real HTTP backend.
// Both MUST implement the same method names / shapes (see mockBackend / httpBackend).
import { mockBackend } from './mock/mockBackend'
import { httpBackend } from './http/httpBackend'

// Default to the mock so local dev/tests keep working with no backend (AC: mock stays
// activatable). Set VITE_USE_MOCK=false (with a real VITE_API_ENDPOINT) to run the journey
// against the Laravel V3 backend.
const USE_MOCK = String(import.meta.env.VITE_USE_MOCK ?? 'true') !== 'false'

export const client = USE_MOCK ? mockBackend : httpBackend
export const isMock = USE_MOCK
